import React, {
    createContext,
    lazy,
    Suspense,
    useContext,
    useState,
} from "react";
import { Modal } from "react-bootstrap";

const SelectSessionModal = lazy(() =>
    import(
        `../_metronic/_partials/selectSession/selectSession`
    ).then(module => ({default : module.SelectSessionModal}))
);

const SessionModalContext = createContext();

export const useSessionModal = () => useContext(SessionModalContext);

export function SessionModalProvider({ children, language }) {
    const [sessionModalOpen, setSessionModalOpen] = useState(false);
    const openSessionModal = () => setSessionModalOpen(true);
    const closeSessionModal = () => setSessionModalOpen(false);

    return (
        <SessionModalContext.Provider
            value={{ openSessionModal, closeSessionModal }}
        >
            {children}

            <Modal
                show={sessionModalOpen}
                onHide={closeSessionModal}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body>
                    <Suspense fallback={<div>loading...</div>}>
                        <SelectSessionModal
                            setSessModalShow={setSessionModalOpen}
                            language={language}
                        />
                    </Suspense>
                </Modal.Body>
            </Modal>
        </SessionModalContext.Provider>
    );
}
